import {useNavigate, useParams} from 'react-router-dom'
import Box from '@mui/material/Box'
import ServiceSetImportTemplate from '../../../components/5templates/ServiceSetImportTemplate'

const ApproveServiceSet = () => {
    const navigate = useNavigate()
    const id = useParams().id

    const onNext = () => {
        navigate(`/approveClient/location/${id}`)
    }
    const onPrev = () => {
        navigate(`/approveClient/client/${id}`)
    }

    return(
        <Box sx={{ marginLeft: '60px', padding: '20px', width: '100%' }}>
            <ServiceSetImportTemplate onNext={onNext}
                                      onPrev={onPrev}
                                      disabled
            />
        </Box>
    )
}

export default ApproveServiceSet
